import { clientPanich } from "../client.panich";
import { type operations } from "../client.panich/schema";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /cart
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type GetCartOperation = operations["get_cart_cart_get"];
export type GetCartProps = GetCartOperation["parameters"];
export type GetCartReturn = GetCartOperation["responses"]["200"]["content"]["application/json"];

export const getCart = async (): Promise<GetCartReturn> => {
  const { data } = await clientPanich.GET(
    `/cart`,
    {
      credentials: "include",
    },
  );

  return data;
};

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /cart/add-item
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type AddItemOperation = operations["add_item_cart_add_item_post"];
export type AddItemProps = AddItemOperation["requestBody"]["content"]["application/json"];
export type AddItemReturn = AddItemOperation["responses"]["200"]["content"]["application/json"];

export const addItem = async (props: AddItemProps): Promise<AddItemReturn> => {
  const { data } = await clientPanich.POST(
    `/cart/add-item`,
    {
      body: props,
      credentials: "include",
    },
  );

  return data;
};

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /cart/set-item-qty
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type SetItemQtyOperation = operations["set_item_qty_cart_set_item_qty_put"];
export type SetItemQtyProps = SetItemQtyOperation["requestBody"]["content"]["application/json"];
export type SetItemQtyReturn = SetItemQtyOperation["responses"]["200"]["content"]["application/json"];

export const setItemQty = async (props: SetItemQtyProps): Promise<SetItemQtyReturn> => {
  const { data } = await clientPanich.PUT(
    `/cart/set-item-qty`,
    {
      body: props,
      credentials: "include",
    },
  );

  return data;
};

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// /cart/remove-items
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

type RemoveItemsOperation = operations["remove_items_cart_remove_items_delete"];
export type RemoveItemsProps = RemoveItemsOperation["requestBody"]["content"]["application/json"];
export type RemoveItemsReturn = RemoveItemsOperation["responses"]["200"]["content"]["application/json"];

export const removeItems = async (props: RemoveItemsProps): Promise<RemoveItemsReturn> => {
  const { data } = await clientPanich.DELETE(
    `/cart/remove-items`,
    {
      body: props,
      credentials: "include",
    },
  );

  return data;
};
